// extracted by mini-css-extract-plugin
export default {"container":"SuccessIBAN_container__Qc9ZZ","title":"SuccessIBAN_title__ltMgR","paragraph":"SuccessIBAN_paragraph__ohjkK","buttonContainer":"SuccessIBAN_buttonContainer__ZBlCL"};